export default __webpack_public_path__ + "static/media/visasMobile.b03cdec3.svg";